import { render, staticRenderFns } from "./orderStatementOrdersSummaryBoxPrint.vue?vue&type=template&id=51c601a5&"
import script from "./orderStatementOrdersSummaryBoxPrint.vue?vue&type=script&lang=ts&"
export * from "./orderStatementOrdersSummaryBoxPrint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports